/**
 * The key to store/retrieve the previously-used camera facing from the browser cookie.
 */
export const CAMERA_SETTINGS = 'cameraSettingsKey';

/**
 * The cookie key to store the bearer token to.
 */
export const AUTH = 'auth';
